export class ProductContent {
  Id: number;
  ProductId: number;
  Data: string;
  Sequence: number;
}
